import { Checkbox, FormControlLabel, FormLabel, Grid, Paper, Radio, RadioGroup, TextField } from "@mui/material";
import { ItemStatus } from "../../constants/Constants";

const EmployeeUpdate = ({ adminRoles,
    employeeSingleData,
    setSingleEmployeeData,
    setMyRoles,
    setMyRolesRules,
    myRolesRules, myRoles,
    formSubmitted, getErrorMessage, setCheckData }) => {


    const checkUnCheckRoles = (checked) => {
        Object.keys(adminRoles).map((key) => (
            setMyRoles(prev => (prev.set(key, checked)))
        ));
        setMyRolesRules(checked);
    }

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        if (name === 'searchJcIdPhone') {
            setCheckData(value);
        } else if (name === 'checkUnCheck') {
            const checked = myRolesRules;
            checkUnCheckRoles(!checked);
        } else if (name === 'haveSalaryComponent') {
            const checked = employeeSingleData.haveSalaryComponent;
            setSingleEmployeeData(prev => ({
                ...prev, haveSalaryComponent: !checked,
            }))
        } else if (name === 'rolechecked') {
            //console.log("handleInputChange", event.target);
            const id = event.target.id;
            const roleValue = myRoles.get(id);

            setMyRoles(m => {
                const nList = new Map(m);
                nList.set(id, !roleValue);
                return nList;
            })
        } else if (name === 'phone') {
            const len = value === '' ? 0 : value.length;
            if ((value === '' || /^\d*$/.test(value)) && len <= 10) {
                setSingleEmployeeData({
                    ...employeeSingleData,
                    phone: value,
                });
            }
        } else {
            setSingleEmployeeData({
                ...employeeSingleData,
                [name]: value,
            });
        }
    };

    return (
        <div>
            {
                employeeSingleData.firstTimeLogin &&
                <Paper elevation={10}
                    autoHeight
                    sx={{
                        display: "flex",
                        flexDirection: "row",
                        backgroundColor: "#d6dfe2",
                        margin: "2px",
                        boxShadow: 1,
                        borderRadius: 5,
                        padding: 2,
                    }} >
                    <Grid item xs={12}>
                        <center>
                            <p>{`First Time Password is: ${employeeSingleData.userPassWord}`}</p>
                        </center>
                    </Grid>

                </Paper>}
            <Paper elevation={10}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#b3ecec",
                    margin: "2px",
                    boxShadow: 1,
                    borderRadius: 5,
                    padding: 2,
                }} >
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <center>
                            <FormLabel component="legend">Enter Employee Status</FormLabel>
                            <RadioGroup row aria-label="activeStatus" name="activeStatus"
                                value={employeeSingleData.activeStatus.toString()} onChange={handleInputChange} style={{
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}>
                                <FormControlLabel value={ItemStatus.ACTIVE.toString()} control={<Radio />} label="Active" />
                                <FormControlLabel value={ItemStatus.INACTIVE.toString()} control={<Radio />} label="InActive" />
                            </RadioGroup>
                        </center>
                    </Grid>
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <TextField
                            required
                            id="name"
                            label="Enter Employee Name"
                            name="name"
                            variant="filled"
                            size="small"
                            value={employeeSingleData.name}
                            onChange={handleInputChange}
                            fullWidth
                            error={formSubmitted && !employeeSingleData.name}
                            helperText={getErrorMessage('name')}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <TextField
                            required
                            id="phone"
                            label="Enter Phone"
                            name="phone"
                            variant="filled"
                            size="small"
                            value={employeeSingleData.phone}
                            onChange={handleInputChange}
                            fullWidth
                            error={formSubmitted && !employeeSingleData.phone}
                            helperText={getErrorMessage('phone')}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <TextField
                            required
                            id="userEmail"
                            variant="filled"
                            size="small"
                            label="Enter Email"
                            name="userEmail"
                            value={employeeSingleData.userEmail}
                            onChange={handleInputChange}
                            fullWidth
                            error={formSubmitted && !employeeSingleData.userEmail}
                            helperText={getErrorMessage('userEmail')}
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <TextField
                            id="employeeType"
                            label="Enter Employee Type"
                            name="employeeType"
                            variant="filled"
                            size="small"
                            value={employeeSingleData.employeeType}
                            onChange={handleInputChange}
                            fullWidth
                        />
                    </Grid>
                    <Grid item xs={12} md={6} sm={6} lg={6}>
                        <TextField
                            id="jcId"
                            label="Unique Id"
                            name="jcId"
                            disabled
                            variant="filled"
                            size="small"
                            value={employeeSingleData.jcId}
                            onChange={handleInputChange}
                            fullWidth
                        />
                    </Grid>
                    {/* {
                        isFeatureAllowed(EMPSALARYMGMT) &&
                        <Grid item xs={12} md={6} sm={6} lg={6}>
                            <FormControlLabel control={<Checkbox
                                checked={employeeSingleData.haveSalaryComponent}
                                onChange={handleInputChange}
                                name="haveSalaryComponent"
                                fullWidth
                                id="haveSalaryComponent"
                            />}
                                label="Add Salary Component" />
                        </Grid>
                    } */}
                </Grid>
            </Paper>
            <Paper elevation={10}
                autoHeight
                sx={{
                    display: "flex",
                    flexDirection: "row",
                    backgroundColor: "#a4b9e1",
                    margin: "2px",
                    boxShadow: 1,
                    borderRadius: 5,
                    padding: 2,
                }} >
                <Grid container>
                    <Grid item xs={12}>
                        <p style={{
                            whiteSpace: "pre-wrap",
                            overflowWrap: "break-word"
                        }}> Employee Role Management.  <FormControlLabel control={<Checkbox
                            checked={myRolesRules}
                            onChange={handleInputChange}
                            name="checkUnCheck"
                            fullWidth
                            id="checkUnCheck"
                        />}
                            label={myRolesRules ? "Unchecked all roles" : "Checked all roles"} />
                        </p>
                    </Grid>
                    {[...myRoles.keys()].map(key => (
                        <Grid item xs={12} md={6} sm={6} lg={6} key={key}>
                            <FormControlLabel control={<Checkbox
                                checked={myRoles.get(key)}
                                onChange={handleInputChange}
                                name="rolechecked"
                                id={key}
                                key={key}
                            />}
                                label={key} />
                        </Grid>
                    ))}
                </Grid>
            </Paper>
        </div>
    )
}

export { EmployeeUpdate };